/* eslint-disable import/prefer-default-export */
import { ContentPageType } from '@app/store/api/customer.types'
import urls, { quizUrls } from '@app/routes/urls'

/**
 * Determines the content type from the path.
 * @param program The program code.
 * @param path The path to determine the content type from.
 * @returns The content type.
 */
export function getContentTypeFromPath(program: string, campaign: string, path: string) {
  const lastPathPart = path.split('/').filter(Boolean).pop()

  if (lastPathPart === program || lastPathPart === campaign) {
    return ContentPageType.LANDING_PAGE
  }
  if (path.includes(urls.closed)) {
    return ContentPageType.CLOSED_PAGE
  }
  if (path.includes(urls.orderComplete)) {
    return ContentPageType.ORDER_PAGE
  }
  if (path.includes(urls.faqs)) {
    return ContentPageType.FAQ_PAGE
  }
  if (path.includes(quizUrls.customer)) {
    return ContentPageType.QUIZ_CUSTOMER_PAGE
  }
  if (path.includes(quizUrls.purchase) || path.includes(quizUrls.model)) {
    return ContentPageType.QUIZ_PURCHASE_PAGE
  }
  if (path.includes(quizUrls.valuation)) {
    return ContentPageType.QUIZ_VALUATION_PAGE
  }
  if (path.includes(quizUrls.shipping)) {
    return ContentPageType.QUIZ_ADDRESS_PAGE
  }
  if (path.includes(quizUrls.payment)) {
    return ContentPageType.QUIZ_PAYMENT_PAGE
  }
  if (path.includes(urls.terms)) {
    return ContentPageType.TERMS_PAGE
  }
  return null
}
